import React, { useState, useEffect } from 'react'
import { COLORES } from '../../../../../config/colores'
import { Button, Col } from 'react-bootstrap'
import preingresoQR from '../../../../../static/preingresoQR.gif'
import KeyboardIcon from '@material-ui/icons/Keyboard'
import NumPad from 'react-numpad'
import ScannerQR from '../../../../Scanner/containers/ScannerQR'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { IconButton } from '@material-ui/core'

export default function PreIngresoCalado1 ({ cancelPreIngreso, cargarPreIngresoCalado, callePreIngreso }) {
  const startTime = () => 15
  const [seconds, setSeconds] = useState(startTime)
  const [numero, setNumero] = useState('')

  const handleChange = (e) => {
    setNumero(e.target.value)
  }

  const ingresoCalado = (numero) => {
    setNumero(numero)
    cargarPreIngresoCalado(numero)
  }

  const handleClick = (e) => {
    e.preventDefault()
    if (String(numero).length === 11) {
      cargarPreIngresoCalado(numero)
    } else {
      cancelPreIngreso()
    }
  }

  const openIngresoManual = () => {
    setSeconds(40)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        clearInterval(interval)
        cancelPreIngreso()
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  })

  return (
    <div style={{ overflow: 'hidden' }} className='ingreso-ctg-preingreso'>
      <NumPad.Number
        className='numpad numpad-grande'
        onChange={(numero) => {
          console.log('Número', numero)
          ingresoCalado(numero)
        }}
        decimal={false}
        negative={false}
      >
        <Button className='btn-ingreso-manual' style={{ marginRigth: '2%' }} onClick={openIngresoManual}>
          <KeyboardIcon fontSize='large' style={{ color: '#ffffff' }} />
        </Button>
      </NumPad.Number>
      <Col style={{ textAlign: 'center', width: '100%', maxHeight: '100%' }}>
        <div style={{ backgroundColor: COLORES.blue.primary, color: '#ffffff', padding: '10px 0', margin: '0 -5% 3% -5%', display: 'flex', flexDirection: 'row' }}>
          <IconButton style={{ color: '#ffffff', margin: '0 0 0 5%' }} onClick={cancelPreIngreso}><ArrowBackIcon /></IconButton>
          <h4 style={{ padding: '10px 0', textAlign: 'left', marginLeft: '8%', marginBottom: '0' }}> Calle {callePreIngreso} </h4>
        </div>
        <h2 style={{ marginLeft: '5%' }} >Por favor escanear el código de su carta de porte</h2>
        <h2 style={{ marginLeft: '5%' }} className='text-preingreso-desktop'>el lector se encuentra en la parte inferior del panel</h2>
      </Col>
      <div className='container-preingreso-desktop'>
        <form style={{ opacity: '0', position: 'absolute', width: '1px' }}>
          <input autoFocus type='number' name='numero' onChange={(e) => { handleChange(e) }} />
          <Button
            type='submit'
            onClick={handleClick}
            size='lg'
            style={{ width: '1px' }}
          >Siguiente</Button>
        </form>
        <div style={{ hight: '470px', overflow: 'hidden' }}>
          <img style={{ width: '65%', position: 'fixed', bottom: '0', left: '0', zIndex: '-10' }} src={preingresoQR} alt='loading...' />
        </div>
      </div>
      <div className='container-preingreso-mobile'>
        <ScannerQR handleSubmit={ingresoCalado} />
      </div>
    </div>
  )
}
